import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CandidateAddressComponent } from './components/candidate-address/candidate-address.component';
import { CandidateExperienceComponent } from './components/candidate-experience/candidate-experience.component';

@NgModule({
  declarations: [CandidateExperienceComponent, CandidateAddressComponent],
  imports: [CommonModule],
  exports: [CandidateExperienceComponent, CandidateAddressComponent],
})
export class CandidateCommonModule {}
